import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from 'shared/store';

export const bannerTypeApi = createApi({
  reducerPath: 'bannerTypeApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Banner', 'Banners', 'Response'],
  endpoints: (builder) => ({
    // Дублирование из features для скрытия ошибки, потом убрать
    getMe: builder.query({
      query: () => ({
        url: '',
      }),
    }),
  }),
});
